module.exports = __webpack_public_path__ + "static/media/banner-ensina-beta.8345d1dd.png";